export interface BetContextualInfo {
    betIndex: number;
    optionId: number | undefined;
    sourceSystem: number;
    pageName?: string;
    moduleLayout?: string;
    moduleType?: string;
    moduleCustomName?: string;
    modulePosition?: string;
}

export enum SourceSystemType {
    Result = 1,
    Participant = 2,
    Option = 3,
}

export interface BetContextualInfoV2 {
    optionId?: number;
    marketType: BetContextualInfoMarketType;
}

export enum BetContextualInfoMarketType {
    TwoUpMarket = 'TwoUpMarket',
}

export enum BetContextAPIVersion {
    V1 = 'V1',
    V2 = 'V2',
}
